import {
    createEmptyOnlyFansSubscriberMessageUsersAutoMessageDetails,
    OnlyFansSubscriberMessageUsersAutoMessageDetails,
} from '../../../types/messageUsersAutoSendWelcomeMessage';
import { stripHtmlAndConvertParagraphs } from '../../../utils/common';

export function normalizeFreeloadersReplyToMessageDetails(
    reply: string | OnlyFansSubscriberMessageUsersAutoMessageDetails,
): OnlyFansSubscriberMessageUsersAutoMessageDetails {
    if (typeof reply === 'string') {
        return {
            ...createEmptyOnlyFansSubscriberMessageUsersAutoMessageDetails(),
            message: stripHtmlAndConvertParagraphs(reply),
        };
    }

    // Preserve HTML for the editor; stripping collapsed saved content vs list preview.
    return {
        ...createEmptyOnlyFansSubscriberMessageUsersAutoMessageDetails(),
        ...reply,
        message: reply.message ?? '',
        mediaFiles: reply.mediaFiles || [],
        mediaFilesPreviews: reply.mediaFilesPreviews || [],
        taggedCreators: reply.taggedCreators || [],
        taggedReleaseForms: reply.taggedReleaseForms || [],
    };
}

export function getFreeloadersReplyPreviewText(reply: string | OnlyFansSubscriberMessageUsersAutoMessageDetails): string {
    if (typeof reply === 'string') {
        return stripHtmlAndConvertParagraphs(reply);
    }

    const base = stripHtmlAndConvertParagraphs(reply.message || '');
    const extras: string[] = [];
    if (reply.mediaFiles?.length) {
        extras.push(`${reply.mediaFiles.length} media`);
    }
    if (reply.lockMessagePrice && reply.lockMessagePrice > 0) {
        extras.push(`PPV $${reply.lockMessagePrice}`);
    }
    if (reply.taggedCreators?.length) {
        extras.push(`${reply.taggedCreators.length} tagged`);
    }

    return extras.length ? `${base}${base ? ' · ' : ''}${extras.join(' · ')}` : base;
}

export function isFreeloadersReplyMessageEmpty(reply: string | OnlyFansSubscriberMessageUsersAutoMessageDetails): boolean {
    if (typeof reply === 'string') {
        return reply.trim() === '';
    }

    return stripHtmlAndConvertParagraphs(reply.message || '').trim() === '';
}
